import api from "../Interceptors/Interceptor";
import { BaseService } from "./BaseService";
import { AxiosResponse } from "axios";
import ApiResponse from "../Models/ApiResponse";

export interface NotificationModel {
    uuid: string
    title: string
    message: string
    path: string
    read: boolean
    includeread: boolean
    notificationTypeCode?: string
}

export class NotificationService extends BaseService<NotificationModel, NotificationModel> {

    protected modelUrl(): string {
        return "notification";
    }

    public async countNotifications(): Promise<AxiosResponse<number>> {
        try {
            let response = await api.get(`v1/${this.modelUrl()}/unread-notifications`, {});
            return response;
        } catch (error) {
            throw error;
        }
    }

    public async markRead(uuid: string) {
        return await api.put(`v1/${this.modelUrl()}/${uuid}/mark-as-read`);
    }

    public async markUnread(uuid: string) {
        return await api.put(`v1/${this.modelUrl()}/${uuid}/mark-as-unread`);
    }
}